import {createContext} from 'react';
const emojiContext =createContext();
export default emojiContext;